import { selectFromRouteDto } from '../../models';

export default selectFromRouteDto()
  .uuid
  .name
  .startDate
  .createdOn
  .projectId
  .hexColor
  .solutionId
  .tags(tag => tag.uuid.name)
  .constraints(constraint => constraint
    .capacity
    .startTime
    .endTime
    .startLocations(startLocation => startLocation.latitude.longitude.address)
    .endLocations(endLocation => endLocation.latitude.longitude.address))
  .activeRouteSolution(routeSolution => routeSolution
    .id
    .routeTimeline(routeTimeline => routeTimeline
      .id
      .eventType
      .sequence
      .arrivalTime
      .departureTime
      .isDeparted))
  .toString();
